exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-action[data-v-2432541d] {\n  text-align: right;\n}\n.create-asset-container[data-v-2432541d] {\n  max-height: 80vh;\n  padding-right: 14px !important;\n  overflow: auto;\n  width: 100%;\n}\n.create-asset-container[data-v-2432541d]  .form-wrapper {\n    width: 100%;\n}\n", ""]);

// exports
